import { createI18n } from './createI18n';

// innerT is synchronously access in components.
// this is a dummy placeholder that wont be called and will be
// replaced by a blocking setup call during app initialize
let innerT = function (str: string) {
  return str;
};

export async function setup() {
  innerT = await createI18n();
}

export default function t(strText: string) {
  const spTranslated =
    typeof window._sp === 'function' ? window._sp(strText) : strText;
  return innerT(spTranslated);
}

export function useI18n() {
  return innerT;
}

export function getTranslations({
  module = '',
  file = '',
  app = '',
}: {
  module: string;
  file: string;
  app: string;
}) {
  if (!file) {
    throw new Error('file name is required');
  }

  function translation(translationKey: string, ...vars: any) {
    return innerT(
      `${app ? `apps:${app}:` : ''}${
        module ? `${module}:` : ''
      }${file}:${translationKey}`,
      ...(vars as [])
    );
  }

  return translation;
}
